<template>
    <div class="">

        <Backer v-if="showbacker != false" />

        
        <b-overlay :show="pullists_being_loaded" rounded="sm">
             <b-card
                no-body
                v-if="name != null"
            >  
                <b-card-body style="padding: 0;"> 
                   <!--  <div style="width: 100%; margin: 0; padding: 0; background: #efefef; height: 40px;">
                        <div style="display: inline-block; padding: 5px; font-weight: bold;">{{name}}</div>
                        <b-button size="sm" variant="danger" @click="name = null" style="display: inline-block;">Close</b-button>
                    </div> -->
                    
                    <ViewPullist :viewdata="name" />
                </b-card-body>

                <b-button size="sm" variant="danger" @click="name = null" style="display: inline-block; width: 100px; margin-top: 10px; margin-bottom: 10px; margin-left: auto; margin-right: auto;">Close</b-button>
            </b-card>
            <div v-else>
                <table style="width: 100%;">
                    <thead>
                        <tr style="background: black; color: white;">
                            <td class="ipt_tdhr" v-on:click="sortby('datetime')">
                                CRTD ON
                            </td>

                            <td class="ipt_tdhr">
                                NAME
                            </td>

                            <td class="ipt_tdhr" v-on:click="sortby('pull_date')">
                                PULL DT
                            </td>

                            <td class="ipt_tdhr" v-on:click="sortby('delivery_date')">
                                DLVR DT
                            </td>

                            <!-- <td class="ipt_tdhr" v-on:click="sortby('truckname')">
                                TRUCK
                            </td> -->
<!-- 
                            <td class="ipt_tdhr" v-on:click="sortby('name')">
                                DEST
                            </td> -->

                            <td class="ipt_tdhr" v-on:click="sortby('nitems')">
                                QTY
                            </td>

                            <td class="ipt_tdhr" v-on:click="sortby('not_pulled')">
                                NOT PLD
                            </td>

                            <td class="ipt_tdhr">
                                ACTIONS
                            </td>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="pullist, idx in pullists" :style="{background: ((pullist.not_pulled > 0) ? '#ffffdd':'snow')}">
                            <td class="ipt_tdr">
                                {{ pullist.datetime }}
                            </td>
                            <td class="ipt_tdr">
                                {{ pullist.name }}
                            </td>
                            <td class="ipt_tdr">
                                <b-form-datepicker 
                                    v-model="pullist.pull_date"
                                    reset-button
                                    style="width: 150px; font-size: 13px; margin: auto;"
                                    size="sm" placeholder="Pull Date"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" 
                                    locale="en-US">
                                </b-form-datepicker>
                            </td>
                            <td class="ipt_tdr">
                                <b-form-datepicker 
                                    v-model="pullist.delivery_date"
                                    reset-button
                                    style="width: 150px; font-size: 13px; margin: auto;"
                                    size="sm" placeholder="Delivery Date"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" 
                                    locale="en-US">        
                                </b-form-datepicker>
                            </td>
                            <!-- <td class="ipt_tdr">
                                <b-input  v-model="pullist.truckname" size="sm" style="width: 150px; margin: auto; font-size: 12px;"></b-input>
                            </td> -->
<!--                             <td class="ipt_tdr" style="font-weight: bold;">
                                {{ pullist.name.split("_")[0] }}
                            </td> -->
                            <td class="ipt_tdr">
                                {{ pullist.nitems }}
                            </td>
                            <td class="ipt_tdr">
                                {{ pullist.not_pulled }}
                            </td>
                            <td class="ipt_tdr" style="width: 80px;">
                                <div style="margin: 5px;"><b-badge size="sm" variant="primary" @click="navigateToPullist(idx)" style="padding: 5px; font-weight: bold; font-size: 14px;">View</b-badge></div>

                                <div style="margin: 5px;"><b-badge size="sm" variant="success" @click="updatePullist(idx)" style="padding: 5px; font-weight: bold; font-size: 14px;" v-if="userDetails.userrole == 'admin'">Update</b-badge></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-overlay>

        <!-- <b-modal id="modal-pullist" scrollable title="Pullist" size="xl" hide-footer>
            <ViewPullist :viewdata="name" />
        </b-modal> -->


    </div>
</template>

<script>
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'
    import ViewPullist from "@/components/ViewPullist"

    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table'

    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'

    export default {
        name: "ListPullists",
        props: ["showbacker"],
        components: {Backer, VueGoodTable, Multiselect, ViewPullist},
        data: function() {
            return {
                pullists: [],
                pullists_being_loaded: false,
                name: null,
                sort_asc: true,
            }
        },
        methods: {
            fetch_prereqs: function(){
                let that = this;
                let prereqs = [];

                for (var i=0; i<prereqs.length; i++) {
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    prereqs[i]["executable"](path, data, s, f);
                }
            },
            fetch_init: function(){
                let that = this;
                let path = "/api/inventory/get_pullists/";
                let data = {type: "st_tran"};
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.pullists = response.data.result;
                    }
                    that.pullists_being_loaded = false;
                    return
                }
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading pullists.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.pullists_being_loaded = false;
                    return
                }
                this.pullists_being_loaded = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            updatePullist: function(idx){
                let pullist = this.pullists[idx];

                let path = "/api/inventory/update_pullist_st_tran_meta/"
                let data = pullist;
                let that = this;
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "Updated pullist", 
                            {title: "Error", autoHideDelay: 1500, variant:"success"}
                        );
                    }
                    that.pullists_being_loaded = false;
                    return
                }
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error updating pullist.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.pullists_being_loaded = false;
                    return
                }
                this.pullists_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);

            },
            navigateToPullist: function(idx){
                let pullist = this.pullists[idx];
                //this.$router.push("/tools/view_pullist/"+pullist.name+"/");
                this.name = pullist.name;
                this.$bvModal.show("modal-pullist");
            },            
            sortby: function(key){
                if (this.sort_asc){
                    this.pullists = Requestor.sort(this.pullists, key)
                }
                else {
                    this.pullists = Requestor.sort_reverse(this.pullists, key)
                }
                this.sort_asc = !this.sort_asc;
            }
        },
        created: function(){
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
                this.fetch_prereqs();
                this.fetch_init();
            }
        }
    }

</script>

<style scoped>
    td {
        background: inherit;
    }
</style>


// WEBPACK FOOTER //
// src/components/ListPullists.vue